var map = {
	"./1.png": "./src/assets/themes/urbe/ilustrations/1.png",
	"./2.png": "./src/assets/themes/urbe/ilustrations/2.png",
	"./3.png": "./src/assets/themes/urbe/ilustrations/3.png",
	"./4.png": "./src/assets/themes/urbe/ilustrations/4.png",
	"./5.png": "./src/assets/themes/urbe/ilustrations/5.png",
	"./6.png": "./src/assets/themes/urbe/ilustrations/6.png",
	"./7.png": "./src/assets/themes/urbe/ilustrations/7.png",
	"./8.png": "./src/assets/themes/urbe/ilustrations/8.png",
	"./9.png": "./src/assets/themes/urbe/ilustrations/9.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/themes/urbe/ilustrations sync \\.png$";